import {
  drawLottery,
  DrawLotteryStatus,
  LotteryType,
} from '@/services/lottery';
import { useEffect, useState } from 'react';
import { useToast } from '@web3/base-hooks';
import { WinResult } from './WinResult';
import { DrawAnimation } from './DrawAnimation';
import { NoWin } from './NoWin';
import { useRedemptionWallet } from '@/hooks/wallet';
import styles from './style.module.scss';

type DrawState = 'drawing' | 'win' | 'lose';

type LotteryModalProps = {
  lotteryType: LotteryType;
  onClose: () => void;
};

const OUT_OF_STOCK = 71001;

export const LuckyDraw = ({ lotteryType, onClose }: LotteryModalProps) => {
  const {
    wallet: { walletId, walletType },
  } = useRedemptionWallet();
  const [drawState, setDrawState] = useState<DrawState>('drawing');
  const [drawResult, setDrawResult] = useState<DrawLotteryStatus | null>(null);
  const { toastFail } = useToast();

  const handleDraw = async (type: LotteryType) => {
    try {
      setDrawState('drawing');
      const response = await drawLottery({ walletId, walletType }, type);

      if (response.success) {
        // NOTE 延迟处理保证动画效果
        await new Promise((resolve) => setTimeout(resolve, 2500));
        setDrawResult(response.result);
        setDrawState('win');
      } else if (response.code === OUT_OF_STOCK) {
        setDrawState('lose');
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toastFail(error.message);
      onClose();
    }
  };

  // 初始抽奖，只一次，后续用户手动抽奖
  useEffect(() => {
    handleDraw(lotteryType);
  }, []);

  // 根据不同状态渲染不同内容
  const renderContent = () => {
    switch (drawState) {
      case 'drawing':
        return <DrawAnimation />;

      case 'win':
        return (
          <WinResult
            drawResult={drawResult}
            onTryAgain={() => handleDraw(lotteryType)}
            onClose={onClose}
            lotteryType={lotteryType}
          />
        );

      case 'lose':
        return <NoWin onClick={onClose} />;
    }
  };

  return (
    <div className={styles['draw-wrap']}>
      <div className="w-full h-full flex items-center justify-center">
        {renderContent()}
      </div>
    </div>
  );
};
